import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "table-title"
}, "数据字典信息", -1);
const _hoisted_2 = {
  style: {
    "padding": "20px"
  }
};
const _hoisted_3 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_layout_breadcrumb = _resolveComponent("layout-breadcrumb");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_table = _resolveComponent("el-table");
  const _component_table_page = _resolveComponent("table-page");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_layout_breadcrumb, {
    topMenuId: _ctx.topMenuId,
    onChangeTopToMenu: _ctx.changeTopToMenu,
    topMenuClick: _ctx.topMenuClick
  }, null, 8, ["topMenuId", "onChangeTopToMenu", "topMenuClick"]), _createVNode(_component_table_page, {
    fetchApi: _ctx.$api.business.dictionary.getList,
    columns: $data.columns,
    topButtons: $data.topButtons,
    linkButtons: $data.linkButtons,
    searchItems: $data.searchItems,
    selectionEnable: false,
    "row-key": "id",
    ref: "tablePage"
  }, {
    toolBarLeft: _withCtx(() => [_hoisted_1]),
    logExpand: _withCtx(data => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_table, {
      data: data.data.items,
      stripe: "",
      border: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_el_table_column, {
        type: "index",
        width: "60",
        label: "#"
      }), _createVNode(_component_el_table_column, {
        label: "字典标签",
        prop: "itemLabel",
        align: "center"
      }), _createVNode(_component_el_table_column, {
        label: "字典键值",
        prop: "itemValue",
        align: "center"
      }), _createVNode(_component_el_table_column, {
        label: "描述",
        prop: "remark",
        align: "center"
      }), _createVNode(_component_el_table_column, {
        label: "字典顺序",
        prop: "sortNo",
        align: "center"
      }), _createVNode(_component_el_table_column, {
        label: "字典状态",
        align: "center"
      }, {
        default: _withCtx(scope => [_ctx.$hasPermission('dictionary_enable') ? (_openBlock(), _createBlock(_component_el_switch, {
          key: 0,
          modelValue: scope.row.enable,
          "onUpdate:modelValue": $event => scope.row.enable = $event,
          onChange: $event => $options.itemChange(scope.row)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])) : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(scope.row.enable ? '启用' : '停用'), 1))]),
        _: 1
      }), _createVNode(_component_el_table_column, {
        label: "操作",
        width: "200px'"
      }, {
        default: _withCtx(scope => [_createVNode(_component_el_button, {
          link: "",
          onClick: $event => $options.editItem(scope.row),
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode("编辑")]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      })]),
      _: 2
    }, 1032, ["data"])])]),
    _: 1
  }, 8, ["fetchApi", "columns", "topButtons", "linkButtons", "searchItems"])]);
}